/** Report compatibility only: no trimming and no posting-eligibility rules. */
export function isExcludedReportPlaceholder(account: {
  is_system?: boolean | null;
  kind?: string | null;
  name?: string | null;
}): boolean {
  return account.is_system === true && (
    ["cash_system", "bank_system"].includes((account.kind ?? "").toLowerCase()) ||
    ["cash_system", "bank_system", "cash system", "bank system"].includes(
      (account.name ?? "").toLowerCase(),
    )
  );
}
